import React from "react";
import styled, { css } from "react-emotion";

const TextBoxStyle = styled("div")`
  text-align: left;
  resize: none;
  /* min-height: 7rem; */
  margin: auto;
  margin-top: 0.5em;
  max-width: 80em;
  background: none;
  color: #1f3747;
  outline: none;
  box-shadow: none;
  border: 1px solid #89d2d3;
  padding: 1rem 1.5rem;
  transition: 0.4s;
`;
const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 20px;
  text-align: center;
`;
const P1 = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
`;
const TextBox = (props) => {
  return (
    <TextBoxStyle>
      <H1>{props.header}</H1>
      <P1>
        <span style={{ fontWeight: "bold" }}>COVID-19 Update: </span>
        {props.text}
      </P1>
      {props.bullets ? (
        <ul style={{ marginLeft: "40px" }}>
          {props.bullets.map((bullet) => {
            return (
              <li>
                <P1>{bullet}</P1>
              </li>
            );
          })}
        </ul>
      ) : null}
    </TextBoxStyle>
  );
};

export default TextBox;
